import React, { useEffect } from "react";
import { Switch, Redirect } from "react-router-dom";

import {
  RouteWithLayout,
  PublicRouteWithLayout,
  PrivateRouteWithLayout,
} from "./components";
import {
  Main as MainLayout,
  MainWithSidebar,
  Minimal as MinimalLayout,
  MainLayoutWithCompany,
} from "./layouts";

import CustomerRoutes from "./Customer_Routes/Routes";

import {
  Login as LoginPage,
  Home as HomePage,
  About as AboutPage,
  Register,
  ForgetPassword,
  SetPassword,
  NotFound,
  GoogleMapTracking,
  RequestScreens,
  Requests,
  ViewRequestDetails,
  SignConfirmationLetter,
  EditRequestExtraItems,
  EditRequestItems,
  AddAddress,
  EditAddress,
} from "./pages";

const Routes = () => {
  //------------------>>ReRender changes on resize window
  // It fixed problem which are accours due to screen resizes

  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  React.useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }
    window.addEventListener("resize", handleResize);
  }, []);
  ///////////////////////////////////////////////////////
  return (
    <Switch>
      <Redirect exact from="/" to="/create-request" />

      <PublicRouteWithLayout
        component={LoginPage}
        exact
        layout={MainLayout}
        path="/login"
      />

      <PublicRouteWithLayout
        component={Register}
        exact
        layout={MainLayout}
        path="/register/:reff"
      />

      <PublicRouteWithLayout
        component={Register}
        exact
        layout={MainLayout}
        path="/register"
      />
      <PublicRouteWithLayout
        component={ForgetPassword}
        layout={MainLayout}
        path="/forget-password"
      />

      <PublicRouteWithLayout
        component={SetPassword}
        exact
        layout={MinimalLayout}
        path="/set-forget-password/:token"
      />

      <RouteWithLayout
        component={RequestScreens}
        exact
        layout={MainLayout}
        path="/create-request"
      />

      <RouteWithLayout
        component={RequestScreens}
        exact
        layout={MainLayoutWithCompany}
        path="/create-request/:direct_link"
      />

      <RouteWithLayout
        component={ViewRequestDetails}
        exact
        layout={MinimalLayout}
        path="/view-request/:access_token"
      />

      <RouteWithLayout
        component={SignConfirmationLetter}
        exact
        layout={MinimalLayout}
        path="/sign-confirmation-letter/:id"
      />
      <RouteWithLayout
        exact
        path="/dashboard/my-requests/edit-extra-items/:requestId"
        component={EditRequestExtraItems}
        layout={MinimalLayout}
      />

      <RouteWithLayout
        exact
        path="/dashboard/my-requests/edit-items/:requestId"
        component={EditRequestItems}
        layout={MinimalLayout}
      />
      <RouteWithLayout
        exact
        path="/dashboard/my-requests/add-address/:requestId"
        component={AddAddress}
        layout={MinimalLayout}
      />
      <RouteWithLayout
        exact
        path="/dashboard/my-requests/edit-address/:requestId/:addressId"
        component={EditAddress}
        layout={MinimalLayout}
      />

      <PrivateRouteWithLayout
        component={CustomerRoutes}
        layout={MainWithSidebar}
        path="/dashboard"
      />

      {/* <RouteWithLayout
        component={GoogleMapTracking}
        exact
        layout={MainLayout}
        path="/map"
      /> */}

      <RouteWithLayout
        component={NotFound}
        exact={false}
        layout={MainLayout}
        path="/"
      />
    </Switch>
  );
};

export default Routes;
